<style>
  .overLoad {
    background-color: #ff9595 !important;
  }


</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0"> اطلاعات فاکتور های شماره نامه '{{inner_Letter.code}}' </h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
            class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>
          <button (click)="OnSet_Back_LetterrequestcustomerFactorList()" type="button" class="btn btn-warning"><i
              class="fa fa-mail-reply"></i>
            بازگشت </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            فایل/های ضمیمه
            <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
            class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>



      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>فایل</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterrequestcustomerFactor">

              <td>{{DataList_LetterrequestcustomerFactor.indexOf(item)+1}}</td>

              <td>

                <a target="_blank" href="{{BaseUrl}}File/Letter/{{item.title}}"
                  class="btn btn-success"><i class="fa fa-file-excel"></i> Excel </a>

              </td>
              <td>
                <button type="button" (click)="DeleteData(item)" class="btn btn-danger"> حذف
                  <i class="fa fa-remove"></i> </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <br/>
      <br/>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #39819b; color: white;">
            <tr>
              <th>#</th>
              <th>نام تجهیز</th>
              <th>تعداد فاکتور شده</th>
              <th>تعداد داخل نامه</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterrequestcustomerFactorDetail"
            [ngClass]="{'overLoad': item['amount']>item['realamount']}">

              <td>{{DataList_LetterrequestcustomerFactorDetail.indexOf(item)+1}}</td>
              <td>{{item['title']}}</td>
              <td>{{item['amount']}}</td>
              <td>{{item['realamount']}}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>